export default {"src":"/_next/static/media/cn.9269fa3e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};